/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Accounting_CodeInputs */

const en_admin_resource_form_accounting_code = /** @type {(inputs: Admin_Resource_Form_Accounting_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounting Code`)
};

const de_admin_resource_form_accounting_code = /** @type {(inputs: Admin_Resource_Form_Accounting_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchungscode`)
};

const es_admin_resource_form_accounting_code = /** @type {(inputs: Admin_Resource_Form_Accounting_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de contabilidad`)
};

const fr_admin_resource_form_accounting_code = /** @type {(inputs: Admin_Resource_Form_Accounting_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code de facturation`)
};

const nl_admin_resource_form_accounting_code = /** @type {(inputs: Admin_Resource_Form_Accounting_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boekhoudcode`)
};

/** @type {(inputs: Admin_Resource_Form_Accounting_CodeInputs) => LocalizedString} */
const it_admin_resource_form_accounting_code = en_admin_resource_form_accounting_code;

/** @type {(inputs: Admin_Resource_Form_Accounting_CodeInputs) => LocalizedString} */
const pt_br2_admin_resource_form_accounting_code = en_admin_resource_form_accounting_code;

/** @type {(inputs: Admin_Resource_Form_Accounting_CodeInputs) => LocalizedString} */
const pl_admin_resource_form_accounting_code = en_admin_resource_form_accounting_code;

/** @type {(inputs: Admin_Resource_Form_Accounting_CodeInputs) => LocalizedString} */
const hu_admin_resource_form_accounting_code = en_admin_resource_form_accounting_code;

/** @type {(inputs: Admin_Resource_Form_Accounting_CodeInputs) => LocalizedString} */
const ro_admin_resource_form_accounting_code = en_admin_resource_form_accounting_code;

/**
* | output |
* | --- |
* | "Accounting Code" |
*
* @param {Admin_Resource_Form_Accounting_CodeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_accounting_code = /** @type {((inputs?: Admin_Resource_Form_Accounting_CodeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Accounting_CodeInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_accounting_code(inputs)
	if (locale === "de") return de_admin_resource_form_accounting_code(inputs)
	if (locale === "es") return es_admin_resource_form_accounting_code(inputs)
	if (locale === "fr") return fr_admin_resource_form_accounting_code(inputs)
	if (locale === "nl") return nl_admin_resource_form_accounting_code(inputs)
	if (locale === "it") return it_admin_resource_form_accounting_code(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_accounting_code(inputs)
	if (locale === "pl") return pl_admin_resource_form_accounting_code(inputs)
	if (locale === "hu") return hu_admin_resource_form_accounting_code(inputs)
	return ro_admin_resource_form_accounting_code(inputs)
});
export { admin_resource_form_accounting_code as "admin.resource_form.accounting_code" }